import React from "react";

import history from "../../auth/history";
import { connect } from "react-redux";
import AddedCustomerDetailsSubComponent from "./AddedConsumerSubComp.jsx";

class AddConsumerList extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }



    render(){
   
    return(
        <div class="addedlist">
        <AddedCustomerDetailsSubComponent/>	
        <AddedCustomerDetailsSubComponent/>	
        <AddedCustomerDetailsSubComponent/>						
        </div>			
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AddConsumerList);
